export const AnalyticsSource = {
  Feed: "feed",
  FeedDetails: "feed_details",
  Search: "search",
  PublicMasterProfile: "master_profile",
  MasterDashboard: "master_dashboard",
  UserMasters: "user_masters",
  Profile: "profile",
  Collection: "collection",
  Direct: "direct",
  Share: "share",
} as const;

export type AnalyticsSourceValue = (typeof AnalyticsSource)[keyof typeof AnalyticsSource];

export const withSource = (url: string, source: AnalyticsSourceValue) => {
  const separator = url.includes("?") ? "&" : "?";

  return `${url}${separator}source=${source}`;
};
